import React from "react";
import { useParams } from "react-router-dom";
import CustomerLiveTracker from "../CustomerLiveTracker";

export default function CustomerTrackerPage() {
    const { deliveryId } = useParams<{ deliveryId: string; }>();
    if (!deliveryId) return <div>No delivery id.</div>;
    return <CustomerLiveTracker tripId={deliveryId} />;
}
